export function Logo({ url, className = "h-10", textClass = "text-xl" }) {
  if (url) return <img src={url} alt="EDEN RP" className={`${className} w-auto`} width="42" height="40" />;
  return (
    <span className={`inline-flex items-baseline font-display font-extrabold tracking-tight ${textClass}`} aria-label="EDEN RP">
      <span className="text-eden-text">EDEN</span>
      <span className="ml-1 text-eden-orange">RP</span>
    </span>
  );
}
